<template>
    <li class="{d:none}@<lg">
        <span class="link-avatar {inline-flex;w:48;h:48} {inline-flex;w:48;h:48;ai:center;jc:center;bg:primary;color:white;cursor:pointer;round}>button" data-bs-toggle="modal" data-bs-target="#headerMenuModal" v-if="member">
            <button v-text="member"></button>
        </span>
        <span class="link-text {px:8;color:primary;font:bold}>a" v-else>
            <a href="login">登入</a>
        </span>
    </li>
    <Teleport to="body">
        <div class="modal fade z:1006!" id="headerMenuModal" tabindex="-1">
            <div class="modal-dialog abs! mt:85! right:14 {right:78}@xl">
                <div class="modal-content p:16 box-shadow:0|0|20|0|black/.4 {abs;content:'';w:52;h:6;bg:url(image/arrow_comment.svg);top:-6;right:16}::before">
                    <div class="
                        modal-body p:0!
                        {p:0;m:0;w:279}_ul
                        {w:full;d:inline-block;h:56;r:20;p:12|32}_li
                        {bg:rgba(94,100,114,0.05)}_li:hover
                        {bg:rgba(255,109,96,0.1)!}_li.logout-btn:hover
                        {flex;gap:16;font-weight:700;f:16;lh:32px;color:gray01;ai:center}_li>a
                        {inline-flex;w:20;h:20;ai:center;jc:center}_li>a>i
                    ">
                        <ul v-if="classicMember">
                            <li class="collapsed {transform:rotate(180deg)}:where(.collapsed)>a>i:last-child" data-bs-toggle="collapse" data-bs-target="#collapseHeaderProfile">
                                <a href="javascript:void(0)">
                                    <i class="fa-regular fa-user"></i>
                                    <span>個人檔案</span>
                                    <i class="fa-solid fa-angle-up ml:auto"></i>
                                </a>
                            </li>
                        </ul>
                        <ul class="collapse" id="collapseHeaderProfile" v-if="classicMember">
                            <li>
                                <a href="profile">
                                    <i></i>
                                    <span>會員資料</span>
                                </a>
                            </li>
                            <li>
                                <a href="resume">
                                    <i></i>
                                    <span>歐趴簡歷</span>
                                </a>
                            </li>
                        </ul>
                        <ul>
                            <li v-if="!classicMember">
                                <a href="profile">
                                    <i class="fa-regular fa-user"></i>
                                    <span>個人檔案</span>
                                </a>
                            </li>
                            <li class="collapsed {transform:rotate(180deg)}:where(.collapsed)>a>i:last-child" data-bs-toggle="collapse" data-bs-target="#collapseHeaderPost">
                                <a href="javascript:void(0)">
                                    <i class="fa-regular fa-rectangle-list"></i>
                                    <span>課程評價</span>
                                    <i class="fa-solid fa-angle-up ml:auto"></i>
                                </a>
                            </li>
                        </ul>
                        <ul class="collapse" id="collapseHeaderPost">
                            <li>
                                <a href="post-list">
                                    <i></i>
                                    <span>我的上傳紀錄</span>
                                </a>
                            </li>
                            <li>
                                <a href="favorite">
                                    <i></i>
                                    <span>我的收藏</span>
                                </a>
                            </li>
                        </ul>
                        <ul v-if="optPart">
                            <li class="collapsed {transform:rotate(180deg)}:where(.collapsed)>a>i:last-child" data-bs-toggle="collapse" data-bs-target="#collapseHeaderTopic">
                                <a href="javascript:void(0)">
                                    <i class="fa-regular fa-comment-dots"></i>
                                    <span>話題趴特</span>
                                    <i class="fa-solid fa-angle-up ml:auto"></i>
                                </a>
                            </li>
                        </ul>
                        <ul class="collapse" id="collapseHeaderTopic" v-if="optPart">
                            <li>
                                <a href="topic-list">
                                    <i></i>
                                    <span>我的上傳紀錄</span>
                                </a>
                            </li>
                            <li>
                                <a href="favorite-topic">
                                    <i></i>
                                    <span>我的收藏</span>
                                </a>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <a href="invitation">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <span>邀請好友紀錄</span>
                                </a>
                            </li>
                            <li>
                                <a href="request-payment">
                                    <i class="fa-solid fa-hand-holding-dollar"></i>
                                    <span>我要請領</span>
                                </a>
                            </li>
                            <li>
                                <a href="activity">
                                    <i class="fa-regular fa-circle-check"></i>
                                    <span>兌換歐趴糖</span>
                                </a>
                            </li>
                            <hr class="my:12 mx:32 bb:1|solid|#E7ECF4">
                            <li class="logout-btn" data-bs-dismiss="modal">
                                <logout-button :path="path"></logout-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const info = useSearchInfo();

    const classicMember = inject("classicMember");
    const optPart = inject("optPart");

    const props = defineProps({
        member: { default: "", type: String },
        path: { type: String }
    });

    onMounted(() => {
        document.querySelector("#headerMenuModal")?.addEventListener("show.bs.modal", () => {
            info.show = false;
            $(document.querySelector("body")).addClass("{z:1004!}_.modal-backdrop");
        });

        document.querySelector("#headerMenuModal")?.addEventListener("hidden.bs.modal", () => {
            $(document.querySelector("body")).removeClass("{z:1004!}_.modal-backdrop");
        });
    });
</script>
